__turbopack_context__.v({
  "actions": "cart-line-row-module-scss-module__Z0ziLa__actions",
  "badge": "cart-line-row-module-scss-module__Z0ziLa__badge",
  "close": "cart-line-row-module-scss-module__Z0ziLa__close",
  "editor": "cart-line-row-module-scss-module__Z0ziLa__editor",
  "editor-actions": "cart-line-row-module-scss-module__Z0ziLa__editor-actions",
  "editor-head": "cart-line-row-module-scss-module__Z0ziLa__editor-head",
  "eyebrow": "cart-line-row-module-scss-module__Z0ziLa__eyebrow",
  "info": "cart-line-row-module-scss-module__Z0ziLa__info",
  "media": "cart-line-row-module-scss-module__Z0ziLa__media",
  "name": "cart-line-row-module-scss-module__Z0ziLa__name",
  "photo": "cart-line-row-module-scss-module__Z0ziLa__photo",
  "price": "cart-line-row-module-scss-module__Z0ziLa__price",
  "qty": "cart-line-row-module-scss-module__Z0ziLa__qty",
  "row": "cart-line-row-module-scss-module__Z0ziLa__row",
  "total": "cart-line-row-module-scss-module__Z0ziLa__total",
  "unit": "cart-line-row-module-scss-module__Z0ziLa__unit",
  "variant": "cart-line-row-module-scss-module__Z0ziLa__variant",
});
